import { Component } from '@angular/core';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DynamicNavigationService } from '../../ui-framework/global-services/dynamic-navigation/dynamic-navigation.service';
import { IMenu } from '../../ui-framework/global-services/models/menu-builder';
import { UserSessionService } from '../../ui-framework/global-services/user-session/user-session.service';



@Component({
    selector: 'app-sidebar',
    imports: [NgScrollbarModule, RouterLinkActive, RouterLink, CommonModule],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
    constructor(
        readonly navigationService: DynamicNavigationService,
        private readonly userSession: UserSessionService
    ) {

    }

    // Generic accordion open-state tracking by hierarchical key like "0-2-1"
    private openKeys = new Set<string>();

    toggle(key: string): void {
        if (this.openKeys.has(key)) {
            this.openKeys.delete(key);
        } else {
            this.openKeys.add(key);
        }
    }

    isOpen(key: string): boolean {
        return this.openKeys.has(key);
    }

    // Map IMenu.state to routerLink under '/dashboard'
    getRouterLink(item: IMenu): string | any[] | null {
        const state = item.state?.trim();
        return state??null;
    }

    getIcon(item: IMenu): string {
        return item.icon || 'format_list_bulleted';
    }

    logout(): void {
        this.userSession.logoutSession();
    }

}
